import React from 'react';
import { PlusSquare, DollarSign, BriefcaseBusiness } from 'lucide-react';

/**
 * Компонент секции дополнительных материалов для укладки плитки
 */
const AdditionalMaterialsSection = ({ formData, handleInputChange, errors }) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <PlusSquare className="w-5 h-5 mr-2 text-fuchsia-500" />
        Дополнительные материалы и работы
      </h3>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {/* Расчет дополнительных материалов */}
        <div className="space-y-4 p-3 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
          <h4 className="text-sm font-medium text-gray-900 dark:text-white">Расчет дополнительных материалов</h4>
          
          <div className="space-y-3">
            {/* Грунтовка */}
            <div className="flex items-center">
              <input
                type="checkbox"
                id="includePrimerCost"
                name="includePrimerCost"
                checked={formData.includePrimerCost}
                onChange={handleInputChange}
                className="form-checkbox"
              />
              <label htmlFor="includePrimerCost" className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                Учитывать грунтовку
              </label>
            </div>
            
            {/* Клей */}
            <div className="flex items-center">
              <input
                type="checkbox"
                id="includeAdhesiveCost"
                name="includeAdhesiveCost"
                checked={formData.includeAdhesiveCost}
                onChange={handleInputChange}
                className="form-checkbox"
              />
              <label htmlFor="includeAdhesiveCost" className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                Учитывать плиточный клей
              </label>
            </div>
            
            {/* Затирка */}
            <div className="flex items-center">
              <input
                type="checkbox"
                id="includeGroutCost"
                name="includeGroutCost"
                checked={formData.includeGroutCost}
                onChange={handleInputChange}
                className="form-checkbox"
              />
              <label htmlFor="includeGroutCost" className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                Учитывать затирку для швов
              </label>
            </div>
          </div>
          
          <div className="text-xs text-gray-500 dark:text-gray-400 mt-2">
            Расчет будет произведен по средним нормам расхода для выбранного типа плитки и поверхности
          </div>
        </div>

        {/* Стоимость работ */}
        <div className="space-y-4 p-3 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
          <h4 className="text-sm font-medium text-gray-900 dark:text-white flex items-center">
            <BriefcaseBusiness className="w-4 h-4 mr-2 text-fuchsia-500" />
            Стоимость работ по укладке
          </h4>
          
          <div>
            <div className="flex items-center mb-3">
              <input
                type="checkbox"
                id="includeLaborCost"
                name="includeLaborCost"
                checked={formData.includeLaborCost}
                onChange={handleInputChange}
                className="form-checkbox"
              />
              <label htmlFor="includeLaborCost" className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                Учитывать стоимость укладки
              </label>
            </div>
            
            {formData.includeLaborCost && (
              <div>
                <label htmlFor="laborPricePerMeter" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
                  <DollarSign className="w-4 h-4 mr-2 text-fuchsia-500" />
                  Стоимость укладки (₽/м²)
                </label>
                <input
                  type="text"
                  id="laborPricePerMeter"
                  name="laborPricePerMeter"
                  value={formData.laborPricePerMeter}
                  onChange={handleInputChange}
                  className={`form-input w-full ${errors.laborPricePerMeter ? 'input-error' : ''}`}
                  placeholder="Стоимость за кв. метр"
                />
                {errors.laborPricePerMeter && (
                  <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                    {errors.laborPricePerMeter}
                  </p>
                )}
              </div>
            )}
          </div>
          
          <div className="text-xs text-gray-500 dark:text-gray-400 mt-2">
            <p>Ориентировочные расценки в России (₽/м²):</p>
            <ul className="list-disc pl-5 mt-1 space-y-1">
              <li>Укладка плитки на пол: 700-1200</li>
              <li>Укладка плитки на стены: 800-1500</li>
              <li>Укладка мозаики: 1500-2500</li>
              <li>Укладка сложной/фигурной плитки: 1200-2000</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="mt-4 p-3 bg-fuchsia-50 dark:bg-fuchsia-900/10 rounded-lg border border-fuchsia-100 dark:border-fuchsia-800 text-xs text-fuchsia-700 dark:text-fuchsia-300">
        <div className="flex items-start">
          <PlusSquare className="w-4 h-4 text-fuchsia-600 dark:text-fuchsia-400 mt-0.5 mr-2 flex-shrink-0" />
          <div>
            Для наиболее точного расчета учтите все дополнительные материалы. 
            Помимо самой плитки, при облицовке требуются грунтовка для подготовки поверхности, 
            плиточный клей для крепления и затирка для заполнения швов. 
            Стоимость работ по укладке может существенно увеличить общий бюджет ремонта.
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdditionalMaterialsSection;